/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './upsertOption.defs.js'
export * as $defs from './upsertOption.defs.js'
